<template lang="pug">

div.table_content
  //- h2(@click="CalcTrueTotal") {{ total_sum_trafic.toLocaleString() }}  |  {{ total_sum_reach.toLocaleString() }}
  .buttons_wrap.mb-5(v-if="updatable_product != product_banner_id")
    .smoother_button#button_unsmooth.mr-3(
      @click="TraficHeadButton('unsmooth')"
      v-tippy="{ theme : 'light-border' }"
      :class="{'active_button': reach, 'superactive': type_of_data == 'unsmooth'}"
      content="Данные (first party data) по выбранному срезу (продукт, платформа, пол и возраст) \
                взяты из Adfox за несколько ближайших периодов в прошлом (1, 7, 14, 31) дней. \
                На основе этих точек построен график для прогнозирования примерного \
                трафика и уников для выбранной продолжительнсти РК."
    ) Прогноз трафика

    .smoother_button#button_raw(
      @click="TraficHeadButton('raw')"
      v-if="hasLen(raw_data) && updatable_product != product_smart_trp_id"
      v-tippy="{ theme : 'light-border' }"
      :class="{'active_button': reach, 'superactive': type_of_data == 'raw'}"
      content="Здесь представлены данные (first party data) полученные из Adfox без изменений."
    ) Сырые данные

  .common_trafic_wrap
    div.pb-3(v-if="!type_of_data || (shown_product != updatable_product && !flex_sheet_nosheet)")
      .traff_reach.mr-6
        strong Трафик РФ: 
        span -
      .traff_reach
        strong Охват: 
        span -

    div.pb-3(v-else-if="type_of_data == 'unsmooth'")
      .traff_reach.mr-6(
        v-if="impressions > limit_impressions"
      )
        span(
          class="too_much_total"
        )
          strong Трафик РФ: 
          span {{ limit_impressions.toLocaleString() }}

      .traff_reach.mr-6(
        v-else-if="impressions <= limit_impressions"
      )
        strong Трафик РФ: 
        span {{ impressions.toLocaleString() }}
    
      .traff_reach(v-if="updatable_product != product_smart_trp_id")
        strong Охват: 
        span {{ reach.toLocaleString() }}

      .traff_reach(v-else)
        strong Минимальный охват РФ: 
        span {{ reach.toLocaleString() }}
    
  //- shown_product - продукт посчитанный в данный момент (для него выведена таблица)
  //- updatable_product = choosen_product - продукт, выбранный в фильтре
  .tables_wrap(v-if="reach && (shown_product == updatable_product || flex_sheet_nosheet)")

    //- Таблица для вывода Smart TRP
    table(v-if="updatable_product == product_smart_trp_id" cellspacing="0" cellpadding="0")
      tr
        th.bordered 
          .in_th
            span Регион
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('name', sortOrderUnsmooth, regions, 'regions')")
        th.bordered
          .in_th
            span Трафик РФ:
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('impressions', sortOrderUnsmooth, regions, 'regions')")
        th
          .in_th
            span Минимальный охват
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('reach', sortOrderUnsmooth, regions, 'regions')")

      tr(v-for="row in regions")

        td.bordered(
          v-if="row.impressions > row.limit_impressions"
          class="too_much"
        ) {{ row.name }}
        td(v-else).bordered {{ row.name }}

        td.bordered(
          v-if="row.impressions > row.limit_impressions"
          class="too_much"
        )
          span.calc_total(ref="data_row" :data-val="row.limit_impressions") {{ parseInt(row.limit_impressions).toLocaleString() }}
        td(v-else).bordered 
          span.calc_total(ref="data_row" :data-val="row.impressions") {{ parseInt(row.impressions).toLocaleString() }}
        
        td.bordered(
          v-if="row.impressions > row.limit_impressions"
          class="too_much"
        )
          span.calc_total(ref="data_row_reach" :data-val="row.reach") {{ row.reach.toLocaleString() }}
        td(v-else)
          span.calc_total(ref="data_row_reach" :data-val="row.reach") {{ row.reach.toLocaleString() }}

    //- Основная таблица для всех продуктов, кроме Smart TRP
    table(v-else-if="type_of_data == 'unsmooth'" cellspacing="0" cellpadding="0")
      tr
        th.bordered 
          .in_th
            span Регион
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('name', sortOrderUnsmooth, regions, 'regions')")
        th.bordered
          .in_th
            span Трафик РФ
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('impressions', sortOrderUnsmooth, regions, 'regions')")
        //- th
        th
          .in_th
            span Охват
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('reach', sortOrderUnsmooth, regions, 'regions')")
      tr(v-for="row in regions")
        td.bordered(
          v-if="row.impressions > row.limit_impressions"
          class="too_much"
        ) {{ row.name }}
        td.bordered(v-else) {{ row.name }}

        td.bordered(
          v-if="row.impressions > row.limit_impressions"
          class="too_much"
        )
          span.calc_total(ref="data_row" :data-val="row.limit_impressions") {{ row.limit_impressions.toLocaleString() }}
        td.bordered(v-else) 
          span.calc_total(ref="data_row" :data-val="row.impressions") {{ row.impressions.toLocaleString() }}
        
        //- td.bordered {{ row.impressions.toLocaleString() }}

        td(
          v-if="row.impressions > row.limit_impressions"
          class="too_much"
        ) 
          span(ref="data_row_reach" :data-val="row.reach") {{ row.reach.toLocaleString() }}
        td(v-else)
          span(ref="data_row_reach" :data-val="row.reach") {{ row.reach.toLocaleString() }}
    
    //- Таблица для сырых данных из Adfox
    table(cellspacing="0" cellpadding="0" v-else)
      tr
        th.bordered
          .in_th
            span Период (в днях)
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('period', sortOrderRaw, raw_data, 'raw_data')")
        th.bordered
          .in_th
            span Платформа
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('device', sortOrderRaw, raw_data, 'raw_data')")
        th.bordered
          .in_th
            span Пол *
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('sex', sortOrderRaw, raw_data, 'raw_data')")
        th.bordered
          .in_th
            span Возраст *
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('age', sortOrderRaw, raw_data, 'raw_data')")
        th.bordered
          .in_th
            span Показы
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('impressions', sortOrderRaw, raw_data, 'raw_data')")
        th
          .in_th
            span Охват РФ
            img(
              src="~@/assets/images/ic_arrow_drop_down.svg"
              @click="SortTable('reach', sortOrderRaw, raw_data, 'raw_data')")
      tr(v-for="row in raw_data")
        td.bordered {{ row.period }}
        td.bordered {{ row.device }}
        td.bordered {{ row.sex }}
        td.bordered {{ row.age }}
        td.bordered {{ parseInt(row.impressions).toLocaleString() }}
        td {{ parseInt(row.reach).toLocaleString() }}

</template>
  
<script>

  export default {
    name: 'CalcTable',
  
    props: {
      reach: null,
      type_of_data: null,
      impressions_ratio: null,
      limit_impressions: null,
      impressions: null,
      regions: null,
      raw_data: null,
      choosen_product: null, //- updatable_product = choosen_product - продукт, выбранный в фильтре
      frequency: null,
      frequency_period: null,
      frequency_period_banner: null,
      frequency_period_value: null,
      shown_product: null, //- shown_product - продукт посчитанный в данный момент (для него выведена таблица)
      slider: null
    },
  
    computed: {
      updatable_product () {
        return this.choosen_product //- updatable_product = choosen_product - продукт, выбранный в фильтре
      },
      flex_sheet_nosheet () {
        return (
          (this.choosen_product === this.product_flex_sheet_id && this.shown_product === this.product_flex_id) ||
          (this.choosen_product === this.product_flex_id && this.shown_product === this.product_flex_sheet_id)
        )
      },
      addition_ratio () {
        if (this.shown_product == this.product_flex_id) {
          return this.FLEX_TOP_LOG_OUTPUT_RATIO;
        } else if (this.shown_product == this.product_flex_sheet_id) {
          return this.FLEX_SHEET_OUTPUT_RATIO;
        }
        return 1;
      }
    },
  
    data () {
      return {
        sortOrderUnsmooth: {},
        sortOrderSmooth: {},
        sortOrderRaw: {},
        total_sum_trafic: 0,
        total_sum_reach: 0,
        product_online_tv: 1,
        product_flex_id: 2,
        product_video_network_web_id: 3,
        product_cinema_id: 4,
        product_banner_id: 5,
        product_smart_tv_id: 6,
        product_flex_sheet_id: 7,
        product_smart_trp_id: 8,
        FLEX_SHEET_OUTPUT_RATIO: 4,
        FLEX_TOP_LOG_OUTPUT_RATIO: 1.38
      }
    },

    methods: {
      CalcTrueTotal () {
        this.total_sum_trafic = 0;
        for (let i=0; i<this.$refs["data_row"].length; i++) {
          let val = parseInt(this.$refs["data_row"][i].dataset.val, 10);
          this.total_sum_trafic += val;
        }
        this.total_sum_reach = 0;
        for (let i=0; i<this.$refs["data_row_reach"].length; i++) {
          let val = parseInt(this.$refs["data_row_reach"][i].dataset.val, 10);
          this.total_sum_reach += val;
        }
      },
      hasLen (value) {
        if (value) {
          if (value.length) {
            return true
          }
        }
        return false
      },
      TraficHeadButton (value) {
        this.$emit("type_of_data_change", value)
      },
      SortTable (field, sort_obj, table, table_name) {
        let t_table = table
        sort_obj[field] = sort_obj[field] === "asc" ? "desc" : "asc";
        t_table.sort((a, b) => {
        if (sort_obj[field] === "asc") {
            return a[field] > b[field] ? 1 : -1;
        } else {
            return a[field] < b[field] ? 1 : -1;
        }
        });
        this.$emit("table_update", t_table, table_name)
      },
    }
  }
</script>
  
<style lang="sass">
  .table_content
    padding: 20px 25px !important
    text-align: left

  .smoother_button
    display: inline-block
    height: 30px
    line-height: 30px
    border: 1px solid #D4D4D4
    border-radius: 30px
    color: #D4D4D4
    text-align: center
    padding: 0 15px
    font-size: 14px
    font-weight: 400
    cursor: default

  .smoother_button.active_button
    color: #696969
    cursor: pointer

  .smoother_button.superactive
    color: #fff
    background-color: #5585C1
    cursor: pointer
    border: 0
  
  .traff_reach
    display: inline-block

  .tables_wrap
    width: 100%
    background-color: #fff
    box-shadow: 0px 2px 4px 0px #00000026
    border-radius: 5px
    table
      width: 100%
      tr
        td.too_much
          background-color: #F8EBC8
        th, td
          padding: 5px 7px
        th.bordered, td.bordered
          border-right: 1px solid #d4d4d4
        th
          border-bottom: 1px solid #d4d4d4
          height: 52px
          .in_th
            display: flex
            justify-content: space-between
            align-items: center
            img
              cursor: pointer

  .too_much_total
    color: #af0800

</style>